var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EngieSnackbar',{attrs:{"value":_vm.value,"color":'green',"text":_vm.text},on:{"input":function($event){return _vm.handleInput($event)},"close":function($event){return _vm.handleClose()}}})}
var staticRenderFns = []

export { render, staticRenderFns }